import { SVGProps } from "react";

import { classNames } from "@helpers/css";

import { TopicflowIconType, getTopicflowIcon } from "./topicflow-icon-helpers";

export const TopicflowIcon = ({
  type,
  ...props
}: { type: TopicflowIconType } & Omit<
  SVGProps<SVGSVGElement>,
  "width" | "height"
>) => {
  const { className, ...rest } = props;
  const Icon = getTopicflowIcon(type);
  if (Icon) {
    return <Icon className={classNames(className, "shrink-0")} {...rest} />;
  }
  return null;
};

export default TopicflowIcon;
